import { editCampaignUrl } from "../constants/urls";
import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { convertFormData } from "@/business/shared/commons/rest/convertToFormData";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { CampaignEditRequest } from "../../domain/campaign";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const editCampaignService = {
    async execute(token: string, editCampaignRequest: CampaignEditRequest): Promise<void> {
        const url = getEnvVariable
            .execute("VUE_APP_DACCACH_URL")
            .concat(editCampaignUrl);

        const formData = convertFormData(editCampaignRequest);

        const headers = {
            "web-token": token,
            Accept: "application/json",
        };

        const response: RestResponse = await restClient().sendRequest(
            url,
            "POST",
            formData,
            headers
        );

        if (!response.isSuccess) {
            const errorMessage =
                response.statusCode == 422
                    ? DaccachErrorActions().extractFormError(response.content)
                    : response.content;
            throw DaccachErrorActions().createError(errorMessage);
        }
    },
};
